import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductsByCategoryId } from 'api/repository/products.api';

export const fetchProductsByCategory = createAsyncThunk(
  'products/fetchByCategory',
  async ({ categoryId, page }, { rejectWithValue }) => {
    try {
      const response = await getProductsByCategoryId(categoryId, page);
      
      const products = response.data.data || response.data.products || response.data;
      
      let categoryName = '';
      if (response.data.category) {
        categoryName = response.data.category.name || response.data.category;
      } else if (response.data.category_name) {
        categoryName = response.data.category_name;
      } else if (products.length > 0 && products[0].category_name) {
        categoryName = products[0].category_name;
      }
      
      return {
        products,
        categoryName,
        totalPages: response.data.last_page || response.data.total_pages || 1,
        page,
        categoryId
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    items: [],
    currentCategoryId: null,
    currentCategoryName: '',
    currentPage: 1,
    totalPages: 1,
    loading: false,
    loadingMore: false,
    error: null,
  },
  reducers: {
    resetProducts: (state) => {
      state.items = [];
      state.currentPage = 1;
      state.error = null;
    },
    setCurrentCategory: (state, action) => {
      state.currentCategoryId = action.payload.id;
      state.currentCategoryName = action.payload.name;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsByCategory.pending, (state, action) => {
        const { page } = action.meta.arg;
        if (page === 1) {
          state.loading = true;
          state.items = [];
        } else {
          state.loadingMore = true;
        }
        state.error = null;
      })
      .addCase(fetchProductsByCategory.fulfilled, (state, action) => {
        const { products, categoryName, totalPages, page, categoryId } = action.payload;        
        if (page === 1) {
          state.items = products;
        } else {
          state.items = [...state.items, ...products];
        }
        
        state.currentCategoryId = categoryId;
        
        if (categoryName && categoryName.trim() !== '') {
          state.currentCategoryName = categoryName;
        }
        
        console.log('Fulfilled - After update, State Category Name:', state.currentCategoryName);
        
        state.currentPage = page;
        state.totalPages = totalPages;
        state.loading = false;
        state.loadingMore = false;
        state.error = null;
      })
      // Fetch products - rejected
      .addCase(fetchProductsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.loadingMore = false;
        state.error = action.payload || 'Failed to load products';
      });
  }
});

export const { resetProducts, setCurrentCategory, clearError } = productsSlice.actions;
export default productsSlice.reducer;
